function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
/**
 * Persistent JavaScript sandbox for the browser Lite Client:
 * opaque iframe (fixed CSP) → Blob Worker.
 *
 * Public surface of a sandbox instance:
 *   initialize()
 *   execute({ source, data, capabilities, handlers, limits })
 *   terminate()
 *
 * This module must remain free of Node.js built-ins (including worker_threads)
 * so Webpack can bundle it for the browser. Node unit tests use sandbox-node.js.
 */

/**
 * Base CSP for the opaque sandbox document.
 * script-src is completed per init with a nonce that authorizes only the
 * trusted iframe bootstrap. Untrusted user code never runs as a document
 * script; it runs only inside the Blob Worker created after handshake.
 *
 * 'unsafe-eval' is required for the existing persistent Worker bootstrap,
 * which compiles validated user source with AsyncFunction. It is not used
 * to deliver or authorize the iframe bootstrap (that is nonce-only). There
 * is still no 'unsafe-inline'.
 */
var SANDBOX_CSP_BASE = ["default-src 'none'", "worker-src blob:", "connect-src 'none'", "object-src 'none'", "base-uri 'none'", "form-action 'none'", "frame-src 'none'", "child-src blob:"];
function buildSandboxCsp(nonce) {
  return [].concat(SANDBOX_CSP_BASE, ["script-src 'nonce-".concat(nonce, "' 'unsafe-eval' blob:")]).join('; ');
}

/** Exported for tests; production inits always build CSP with a fresh nonce. */
var SANDBOX_CSP = buildSandboxCsp('saito-sandbox');
function createBootstrapNonce() {
  // Prefer Web Crypto on globalThis (browsers and modern Node). Avoid the
  // Node `crypto` module binding — this file must stay Webpack-safe.
  var webCrypto = typeof globalThis !== 'undefined' ? globalThis.crypto : null;
  if (webCrypto && typeof webCrypto.getRandomValues === 'function') {
    var bytes = new Uint8Array(16);
    webCrypto.getRandomValues(bytes);
    return Array.from(bytes, function (b) {
      return b.toString(16).padStart(2, '0');
    }).join('');
  }
  throw new Error('Sandbox bootstrap nonce requires Web Crypto getRandomValues');
}
function escapeInlineScript(source) {
  // Prevent early </script> termination if the trusted source ever contains it.
  return String(source).replace(/<\/(script)/gi, '<\\/$1');
}
function jsonSafeClone(value, label) {
  try {
    return JSON.parse(JSON.stringify(value === undefined ? null : value));
  } catch (err) {
    throw new Error("Invalid ".concat(label, ": ").concat(err.message));
  }
}
function measureMessageSize(message) {
  return JSON.stringify(message).length;
}

/**
 * Trusted Worker bootstrap. Speaks EXEC / EXEC_RESULT / capability messages.
 */
function getWorkerBootstrapSource() {
  return "\n'use strict';\n(function () {\n  var pendingCaps = Object.create(null);\n  var nextCapId = 1;\n  var terminated = false;\n\n  function getPort() {\n    return {\n      post: function (msg) { self.postMessage(msg); },\n      onMessage: function (handler) {\n        self.onmessage = function (ev) { handler(ev.data); };\n      }\n    };\n  }\n\n  var port = getPort();\n\n  function reply(type, requestId, ok, value, error) {\n    var msg = { type: type, requestId: requestId, ok: ok };\n    if (ok) {\n      msg.value = value;\n    } else {\n      msg.error = error || 'Unknown error';\n    }\n    port.post(msg);\n  }\n\n  function capabilityCall(namespace, method, args) {\n    var requestId = nextCapId++;\n    return new Promise(function (resolve, reject) {\n      pendingCaps[requestId] = { resolve: resolve, reject: reject };\n      port.post({\n        type: 'CAPABILITY_REQUEST',\n        requestId: requestId,\n        namespace: namespace,\n        method: method,\n        args: args || []\n      });\n    });\n  }\n\n  function buildCapabilities(descriptors) {\n    var iface = Object.create(null);\n    var namespaces = Object.keys(descriptors || {});\n    for (var i = 0; i < namespaces.length; i++) {\n      var ns = namespaces[i];\n      var methods = descriptors[ns] || [];\n      var obj = Object.create(null);\n      for (var j = 0; j < methods.length; j++) {\n        (function (namespace, method) {\n          obj[method] = function () {\n            var args = Array.prototype.slice.call(arguments);\n            return capabilityCall(namespace, method, args);\n          };\n        })(ns, methods[j]);\n      }\n      iface[ns] = obj;\n    }\n    return iface;\n  }\n\n  function runUserSource(source, paramNames, paramValues) {\n    var AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;\n    var body = String(source) + '\\n';\n    var fn = AsyncFunction.apply(null, paramNames.concat([body]));\n    return fn.apply(null, paramValues);\n  }\n\n  port.onMessage(async function (msg) {\n    if (!msg || typeof msg !== 'object' || terminated) {\n      return;\n    }\n\n    if (msg.type === 'CAPABILITY_RESULT') {\n      var waiter = pendingCaps[msg.requestId];\n      if (!waiter) {\n        return;\n      }\n      delete pendingCaps[msg.requestId];\n      if (msg.ok) {\n        waiter.resolve(msg.value);\n      } else {\n        waiter.reject(new Error(msg.error || 'Capability request failed'));\n      }\n      return;\n    }\n\n    if (msg.type === 'TERMINATE') {\n      terminated = true;\n      var ids = Object.keys(pendingCaps);\n      for (var i = 0; i < ids.length; i++) {\n        pendingCaps[ids[i]].reject(new Error('Execution terminated'));\n        delete pendingCaps[ids[i]];\n      }\n      return;\n    }\n\n    if (msg.type === 'PING') {\n      reply('PONG', msg.requestId, true, null);\n      return;\n    }\n\n    if (msg.type === 'EXEC') {\n      try {\n        var caps = buildCapabilities(msg.capabilities || {});\n        var data = msg.data || {};\n        var paramNames = [];\n        var paramValues = [];\n        var nsNames = Object.keys(caps);\n        for (var n = 0; n < nsNames.length; n++) {\n          paramNames.push(nsNames[n]);\n          paramValues.push(caps[nsNames[n]]);\n        }\n        var dataKeys = Object.keys(data);\n        for (var d = 0; d < dataKeys.length; d++) {\n          paramNames.push(dataKeys[d]);\n          paramValues.push(data[dataKeys[d]]);\n        }\n        var result = await runUserSource(msg.source || '', paramNames, paramValues);\n        reply('EXEC_RESULT', msg.requestId, true, result === undefined ? null : result);\n      } catch (err) {\n        reply('EXEC_RESULT', msg.requestId, false, null, err && err.message ? err.message : String(err));\n      }\n    }\n  });\n\n  port.post({ type: 'WORKER_READY' });\n})();\n";
}
function getIframeBootstrapSource() {
  return "\n'use strict';\n(function () {\n  var worker = null;\n  var workerBlobUrl = null;\n  var parentOrigin = '*';\n  var waitingForWorkerReady = false;\n\n  function postToParent(msg) {\n    parent.postMessage(msg, parentOrigin);\n  }\n\n  function revokeWorkerBlob() {\n    if (workerBlobUrl) {\n      try {\n        URL.revokeObjectURL(workerBlobUrl);\n      } catch (e) {}\n      workerBlobUrl = null;\n    }\n  }\n\n  function createWorker(bootstrapSource) {\n    var blob = new Blob([bootstrapSource], { type: 'application/javascript' });\n    // Do not revoke immediately: Chromium can fail to fetch the Worker script\n    // if the Blob URL is revoked before the worker finishes loading.\n    workerBlobUrl = URL.createObjectURL(blob);\n    worker = new Worker(workerBlobUrl);\n    waitingForWorkerReady = true;\n    worker.onmessage = function (ev) {\n      var msg = ev.data;\n      if (\n        waitingForWorkerReady &&\n        msg &&\n        typeof msg === 'object' &&\n        msg.type === 'WORKER_READY'\n      ) {\n        waitingForWorkerReady = false;\n        postToParent({\n          channel: 'saito-sandbox',\n          from: 'iframe',\n          payload: { type: 'SANDBOX_READY' }\n        });\n      }\n      postToParent({ channel: 'saito-sandbox', from: 'worker', payload: msg });\n    };\n    worker.onerror = function (err) {\n      waitingForWorkerReady = false;\n      postToParent({\n        channel: 'saito-sandbox',\n        from: 'iframe',\n        payload: {\n          type: 'WORKER_ERROR',\n          error: err && err.message ? err.message : 'Worker error'\n        }\n      });\n    };\n  }\n\n  window.addEventListener('message', function (ev) {\n    var data = ev.data;\n    if (!data || data.channel !== 'saito-sandbox' || data.from !== 'parent') {\n      return;\n    }\n    var payload = data.payload;\n    if (!payload || typeof payload !== 'object') {\n      return;\n    }\n    if (payload.type === 'BOOTSTRAP') {\n      try {\n        createWorker(payload.workerBootstrap);\n        // SANDBOX_READY is posted only after the Worker emits WORKER_READY.\n      } catch (err) {\n        waitingForWorkerReady = false;\n        postToParent({\n          channel: 'saito-sandbox',\n          from: 'iframe',\n          payload: {\n            type: 'SANDBOX_ERROR',\n            error: err && err.message ? err.message : String(err)\n          }\n        });\n      }\n      return;\n    }\n    if (!worker) {\n      return;\n    }\n    if (payload.type === 'TERMINATE') {\n      try {\n        worker.postMessage({ type: 'TERMINATE' });\n        worker.terminate();\n      } catch (e) {}\n      worker = null;\n      waitingForWorkerReady = false;\n      revokeWorkerBlob();\n      return;\n    }\n    worker.postMessage(payload);\n  });\n\n  postToParent({ channel: 'saito-sandbox', from: 'iframe', payload: { type: 'IFRAME_READY' } });\n})();\n";
}
function canUseBrowserSandbox() {
  return typeof document !== 'undefined' && typeof document.createElement === 'function' && typeof Blob !== 'undefined' && typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function' && typeof Worker !== 'undefined';
}
function createSandbox() {
  var state = {
    kind: null,
    terminated: false,
    initialized: false,
    iframe: null,
    iframeUrl: null,
    nextRequestId: 1,
    pending: new Map(),
    currentHandlers: null,
    messageCount: 0,
    maxMessages: 1000,
    maxMessageSize: 65536,
    queue: Promise.resolve(),
    onParentMessage: null
  };
  function rejectAll(reason) {
    var _iterator = _createForOfIteratorHelper(state.pending),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          pending = _step$value[1];
        pending.reject(reason);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    state.pending.clear();
  }
  function postToIsolate(payload) {
    if (!state.iframe || !state.iframe.contentWindow) {
      throw new Error('Sandbox iframe is not available');
    }
    state.iframe.contentWindow.postMessage({
      channel: 'saito-sandbox',
      from: 'parent',
      payload: payload
    }, '*');
  }
  function handleIsolatePayload(payload) {
    if (!payload || _typeof(payload) !== 'object' || state.terminated) {
      return;
    }
    if (payload.type === 'WORKER_READY' || payload.type === 'PONG') {
      var pendingReady = state.pending.get(payload.requestId);
      if (pendingReady && pendingReady.responseType === payload.type) {
        state.pending["delete"](payload.requestId);
        pendingReady.resolve(true);
      }
      return;
    }
    if (payload.type === 'WORKER_ERROR' || payload.type === 'SANDBOX_ERROR') {
      var err = new Error(payload.error || 'Sandbox error');
      rejectAll(err);
      return;
    }
    if (payload.type === 'CAPABILITY_REQUEST') {
      state.messageCount += 1;
      if (state.messageCount > state.maxMessages) {
        rejectAll(new Error('Worker exceeded maxMessages'));
        return;
      }
      handleCapabilityRequest(payload);
      return;
    }
    if (payload.type === 'EXEC_RESULT') {
      state.messageCount += 1;
      var pending = state.pending.get(payload.requestId);
      if (!pending || pending.responseType !== 'EXEC_RESULT') {
        return;
      }
      state.pending["delete"](payload.requestId);
      if (payload.ok) {
        try {
          pending.resolve(jsonSafeClone(payload.value, 'worker result'));
        } catch (err) {
          pending.reject(err);
        }
      } else {
        pending.reject(new Error(payload.error || 'Worker request failed'));
      }
    }
  }
  function handleCapabilityRequest(_x) {
    return _handleCapabilityRequest.apply(this, arguments);
  }
  function _handleCapabilityRequest() {
    _handleCapabilityRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(msg) {
      var requestId, handlers, args, entry, result, value, response, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            requestId = msg.requestId;
            handlers = state.currentHandlers;
            _context3.p = 1;
            if (!(!handlers || typeof msg.namespace !== 'string' || typeof msg.method !== 'string')) {
              _context3.n = 2;
              break;
            }
            throw new Error('Malformed capability request');
          case 2:
            if (!(!handlers[msg.namespace] || !handlers[msg.namespace][msg.method])) {
              _context3.n = 3;
              break;
            }
            throw new Error("Unauthorized capability: ".concat(msg.namespace, ".").concat(msg.method));
          case 3:
            args = jsonSafeClone(msg.args || [], 'capability args');
            entry = handlers[msg.namespace][msg.method];
            if (entry.validateArgs) {
              entry.validateArgs(args);
            }
            _context3.n = 4;
            return entry.fn.apply(entry, _toConsumableArray(args));
          case 4:
            result = _context3.v;
            value = jsonSafeClone(result === undefined ? null : result, 'capability result');
            response = {
              type: 'CAPABILITY_RESULT',
              requestId: requestId,
              ok: true,
              value: value
            };
            if (!(measureMessageSize(response) > state.maxMessageSize)) {
              _context3.n = 5;
              break;
            }
            throw new Error('Capability result exceeds maxMessageSize');
          case 5:
            postToIsolate(response);
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t2 = _context3.v;
            try {
              postToIsolate({
                type: 'CAPABILITY_RESULT',
                requestId: requestId,
                ok: false,
                error: _t2 && _t2.message ? _t2.message : String(_t2)
              });
            } catch (_err) {
              rejectAll(new Error('Failed to deliver capability error'));
            }
          case 7:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 6]]);
    }));
    return _handleCapabilityRequest.apply(this, arguments);
  }
  function sendRequest(type, payload, responseType, timeoutMs) {
    if (state.terminated) {
      return Promise.reject(new Error('Sandbox terminated'));
    }
    var requestId = state.nextRequestId++;
    var message = _objectSpread({
      type: type,
      requestId: requestId
    }, payload);
    var size;
    try {
      size = measureMessageSize(message);
    } catch (err) {
      return Promise.reject(new Error("Unable to serialize sandbox message: ".concat(err.message)));
    }
    if (size > state.maxMessageSize) {
      return Promise.reject(new Error('Host message exceeds maxMessageSize'));
    }
    return new Promise(function (_resolve, _reject) {
      var timer = timeoutMs > 0 ? setTimeout(function () {
        if (state.pending.has(requestId)) {
          state.pending["delete"](requestId);
          _reject(new Error('Execution timed out'));
        }
      }, timeoutMs) : null;
      state.pending.set(requestId, {
        resolve: function resolve(value) {
          if (timer) {
            clearTimeout(timer);
          }
          _resolve(value);
        },
        reject: function reject(err) {
          if (timer) {
            clearTimeout(timer);
          }
          _reject(err);
        },
        responseType: responseType
      });
      try {
        postToIsolate(message);
      } catch (err) {
        state.pending["delete"](requestId);
        if (timer) {
          clearTimeout(timer);
        }
        _reject(err);
      }
    });
  }
  function initializeBrowser() {
    return _initializeBrowser.apply(this, arguments);
  }
  function _initializeBrowser() {
    _initializeBrowser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var nonce, bootstrap, html, htmlBlob, iframe;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // Opaque-origin iframes (sandbox without allow-same-origin) cannot load
            // parent-created Blob script URLs. Deliver the trusted bootstrap as an
            // inline script authorized only by a per-init CSP nonce. Saito parent
            // pages currently ship no CSP; the iframe meta policy is therefore the
            // effective document policy. A later parent CSP cannot be loosened by
            // this meta tag — if one is added that blocks this bootstrap, init must
            // fail closed rather than weaken sandbox flags.
            nonce = createBootstrapNonce();
            bootstrap = escapeInlineScript(getIframeBootstrapSource());
            html = "<!DOCTYPE html>\n<html>\n<head>\n<meta charset=\"utf-8\">\n<meta http-equiv=\"Content-Security-Policy\" content=\"".concat(buildSandboxCsp(nonce), "\">\n</head>\n<body>\n<script nonce=\"").concat(nonce, "\">").concat(bootstrap, "</script>\n</body>\n</html>");
            htmlBlob = new Blob([html], {
              type: 'text/html'
            });
            state.iframeUrl = URL.createObjectURL(htmlBlob);
            iframe = document.createElement('iframe');
            iframe.setAttribute('sandbox', 'allow-scripts');
            iframe.style.display = 'none';
            iframe.setAttribute('aria-hidden', 'true');
            iframe.src = state.iframeUrl;
            state.kind = 'browser';
            state.iframe = iframe;
            _context4.n = 1;
            return new Promise(function (resolve, reject) {
              var timeout = setTimeout(function () {
                reject(new Error('Sandbox iframe initialization timed out'));
              }, 10000);
              var settled = false;
              var settleOk = function settleOk() {
                if (settled) {
                  return;
                }
                settled = true;
                clearTimeout(timeout);
                resolve(true);
              };
              var settleErr = function settleErr(err) {
                if (settled) {
                  return;
                }
                settled = true;
                clearTimeout(timeout);
                reject(err);
              };
              state.onParentMessage = function (event) {
                if (event.source !== iframe.contentWindow) {
                  return;
                }
                var data = event.data;
                if (!data || data.channel !== 'saito-sandbox') {
                  return;
                }
                if (data.from !== 'iframe' && data.from !== 'worker') {
                  return;
                }
                var payload = data.payload;
                if (!payload) {
                  return;
                }
                if (payload.type === 'IFRAME_READY') {
                  try {
                    postToIsolate({
                      type: 'BOOTSTRAP',
                      workerBootstrap: getWorkerBootstrapSource()
                    });
                  } catch (err) {
                    settleErr(err);
                  }
                  return;
                }
                if (payload.type === 'SANDBOX_READY') {
                  settleOk();
                  return;
                }
                if (payload.type === 'SANDBOX_ERROR') {
                  settleErr(new Error(payload.error || 'Sandbox failed to start'));
                  return;
                }
                handleIsolatePayload(payload);
              };
              window.addEventListener('message', state.onParentMessage);
              if (!document.body) {
                settleErr(new Error('document.body is required to mount the sandbox iframe'));
                return;
              }
              document.body.appendChild(iframe);
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _initializeBrowser.apply(this, arguments);
  }
  var sandbox = {
    isTerminated: function isTerminated() {
      return state.terminated;
    },
    initialize: function initialize() {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!state.terminated) {
                _context.n = 1;
                break;
              }
              throw new Error('Sandbox terminated');
            case 1:
              if (!state.initialized) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (canUseBrowserSandbox()) {
                _context.n = 3;
                break;
              }
              throw new Error('JavaScript isolation unavailable: sandboxed iframe/Worker requires a browser environment');
            case 3:
              _context.n = 4;
              return initializeBrowser();
            case 4:
              state.initialized = true;
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    execute: function execute(job) {
      var run = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var limits, maxExecutionTime, _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (!(state.terminated || !state.initialized)) {
                  _context2.n = 1;
                  break;
                }
                throw new Error('Sandbox is not ready');
              case 1:
                limits = job.limits || {};
                maxExecutionTime = Number(limits.maxExecutionTime) > 0 ? Number(limits.maxExecutionTime) : 5000;
                state.maxMessages = Number(limits.maxMessages) > 0 ? Number(limits.maxMessages) : 1000;
                state.maxMessageSize = Number(limits.maxMessageSize) > 0 ? Number(limits.maxMessageSize) : 65536;
                state.currentHandlers = job.handlers || null;
                _context2.p = 2;
                _context2.n = 3;
                return sendRequest('EXEC', {
                  source: job.source,
                  data: job.data || {},
                  capabilities: job.capabilities || {}
                }, 'EXEC_RESULT', maxExecutionTime);
              case 3:
                return _context2.a(2, _context2.v);
              case 4:
                _context2.p = 4;
                _t = _context2.v;
                // A hung Worker cannot serve later EXECs; tear down so the next
                // executeJS call can recreate a clean sandbox.
                if (_t && /timed out/i.test(String(_t.message || _t))) {
                  sandbox.terminate();
                }
                throw _t;
              case 5:
                _context2.p = 5;
                state.currentHandlers = null;
                return _context2.f(5);
              case 6:
                return _context2.a(2);
            }
          }, _callee2, null, [[2, 4, 5, 6]]);
        }));
        return function run() {
          return _ref.apply(this, arguments);
        };
      }();
      var queued = state.queue.then(run, run);
      state.queue = queued.then(function () {
        return undefined;
      }, function () {
        return undefined;
      });
      return queued;
    },
    terminate: function terminate() {
      if (state.terminated) {
        return;
      }
      state.terminated = true;
      state.initialized = false;
      rejectAll(new Error('Sandbox terminated'));
      try {
        postToIsolate({
          type: 'TERMINATE'
        });
      } catch (_err) {
        // ignore
      }
      if (state.onParentMessage) {
        try {
          window.removeEventListener('message', state.onParentMessage);
        } catch (_err) {
          // ignore
        }
      }
      if (state.iframe && state.iframe.parentNode) {
        state.iframe.parentNode.removeChild(state.iframe);
      }
      state.iframe = null;
      if (state.iframeUrl) {
        try {
          URL.revokeObjectURL(state.iframeUrl);
        } catch (_err) {
          // ignore
        }
        state.iframeUrl = null;
      }
      state.kind = null;
    }
  };
  return sandbox;
}
module.exports = {
  createSandbox: createSandbox,
  SANDBOX_CSP: SANDBOX_CSP,
  buildSandboxCsp: buildSandboxCsp,
  createBootstrapNonce: createBootstrapNonce,
  escapeInlineScript: escapeInlineScript,
  getIframeBootstrapSource: getIframeBootstrapSource,
  getWorkerBootstrapSource: getWorkerBootstrapSource
};